module.exports = __webpack_public_path__ + "img/picture4.79550c7e.png";